export default __webpack_public_path__ + "static/media/wallpaper.01705941.jpg";